export default __webpack_public_path__ + "static/media/hero-image.1221fd31.png";